const ttaeDataLayerPushFactory = (data?: any, sourceUrl?: string) => ({
  event: "dataLayerPush",
  formData: {
    Location: sourceUrl ?? "",
    Name: "Talk to an Expert",
    Type: "Nextjs",
    firstname: data?.firstName ?? "",
    lastname: data?.lastName ?? "",
    email: data?.email ?? "",
    phone: data?.phone ?? "",
    "yes i am a travel professional": data?.isTravelAgent?.toString() ?? "",
    "yes i am traveling with 8 or more people": data?.withMoreTravelers?.toString() ?? "",
    "yes i am working with a travel professional": data?.workingWithAgent?.toString() ?? ""
  }
});

export default ttaeDataLayerPushFactory;